import "./index.scss";

const EVENT_NAME = {
  PINED_TOP: "on_parallax_pined_top",
  UN_PIN_TOP: "on_parallax_un_pin_top",
  UN_PIN: "on_parallax_un_pin",
};

export default class Parallax {
  timerScroll = null;
  timerZoom = null;
  $el = null;
  $children = null;
  vNode = null;
  clipRate = 11.4;
  constructor(el, vNode) {
    this.$el = el;
    this.$children = Array.from(this.$el.childNodes);
    this.vNode = vNode;

    this.init();
  }

  init() {
    this.$el.classList.add("parallax-box");
    $(this.$children).addClass("parallax-box-children");
    this.$children.map((el, key) => {
      el.dataset.page = key;
      el.style.zIndex = 99 - key;
    });

    // 处理绘画图滚动放大效果
    this.first_paint_zoom_effect();
    this.scroll_handle();
  }

  destroy() {
    cancelAnimationFrame(this.timerScroll);
    cancelAnimationFrame(this.timerZoom);
  }

  /**
   * 滚动处理
   */
  scroll_handle() {
    let self = this;
    let scrollTop = -1;
    this.timerScroll = requestAnimationFrame(function fn() {
      if (scrollTop !== document.documentElement.scrollTop) {
        self.scroll_effect_handler();
        scrollTop = document.documentElement.scrollTop;
      }
      self.timerScroll = requestAnimationFrame(fn);
    });
  }

  /**
   * 处理滚动事件,attr,以及滚动效果
   */
  scroll_effect_handler() {
    let wHeight = $(window).height();
    this.$children.map((el, index) => {
      let { height, top } = el.getBoundingClientRect();
      el.parallaxStatus = el.parallaxStatus ?? {
        top: false,
        pined: false,
        unpin: true,
      };

      let offsetTop = el.classList.contains("link-above") ? top : top + wHeight;
      let offsetHeight = el.classList.contains("link-above-parent")
        ? height - wHeight
        : height;

      if (index === 0) {
        offsetTop = offsetTop - wHeight;
      }

      if (offsetTop <= 0) {
        let isOutEdge = el.classList.contains("link-above")
          ? Math.abs(offsetTop) + wHeight < offsetHeight
          : Math.abs(offsetTop) + (index === 0 ? 0 : wHeight) <=
            offsetHeight - wHeight;

        //  v-page 刚到页面顶部, top = 0
        if (el.parallaxStatus.unpin && isOutEdge) {
          el.parallaxStatus.top = true;
          el.parallaxStatus.pined = true;
          el.parallaxStatus.unpin = false;
          this.emit(EVENT_NAME.PINED_TOP, index);
        }

        //  v-page 已经处于pined状态, top < 0
        if (
          wHeight - top <= height &&
          offsetTop < -30 &&
          el.parallaxStatus.top
        ) {
          el.parallaxStatus.top = false;
          this.emit(EVENT_NAME.UN_PIN_TOP, index);
        }
      } else {
        //   v-page 处于unpin状态, top > 0
        if (el.parallaxStatus.pined) {
          el.parallaxStatus.top = false;
          el.parallaxStatus.pined = false;
          el.parallaxStatus.unpin = true;
          this.emit(EVENT_NAME.UN_PIN, index);
        }
      }

      //   v-page 处于unpin状态,  bottom < 0
      if (wHeight - top > offsetHeight) {
        if (!el.parallaxStatus.unpin) {
          el.parallaxStatus.top = false;
          el.parallaxStatus.pined = false;
          el.parallaxStatus.unpin = true;
          this.emit(EVENT_NAME.UN_PIN, index);
        }
      }

      el.dataset.pinedTop = el.parallaxStatus.top;
      el.dataset.pined = el.parallaxStatus.pined;
      el.dataset.unpin = el.parallaxStatus.unpin;
    });
  }

  /**
   * 触发事件
   * @param evenName
   * @param index
   */
  emit(evenName, index) {
    let vNode = this.vNode.children[index];
    if (!vNode) return;
    this.emit_event_deeply(vNode, evenName, index);
  }

  /**
   * 递归触发事件
   * @param vNode
   * @param eventName
   */
  emit_event_deeply(vNode, eventName, index) {
    if (vNode?.componentInstance && vNode?.componentInstance[eventName]) {
      vNode?.componentInstance[eventName].call(vNode.componentInstance, {
        index: index,
        parentsVNode: this.vNode,
      });
    }

    if (vNode?.componentOptions?.children?.length) {
      vNode.componentOptions.children.map((vN) => {
        this.emit_event_deeply(vN, eventName, index);
      });
    }
  }

  /**
   * 绘画图第一个滚动放大效果
   */
  first_paint_zoom_effect() {
    let scrollTargets = [];
    let self = this;
    $(this.$children).map((key, el) => {
      if ($(el).hasClass("link-above") && key !== 0) {
        let prevEl = $(this.$children[key - 1]);
        let prevContent = prevEl.find(".v-page-content");
        if (prevContent.length > 0) {
          //  1。 绘画图前一个元素需要给v-page-content一个padding-bottom 100vh的值
          prevContent.css("padding-bottom", "100vh");
          prevEl.addClass("link-above-parent");
          //  2。 绘画图的z-index要大于前一个元素
          let index = $(el).css("zIndex");
          $(el).css("zIndex", parseInt(index) + 2);
          //  3。 绘画图整体 margin-top -100vh
          $(el).css("top", "-100vh");
          $(el).css("min-height", "100vh");
          scrollTargets.push(el);
        }
      }
    });

    let scrollTop = -1;
    this.timerZoom = requestAnimationFrame(function fn() {
      if (scrollTop !== document.documentElement.scrollTop) {
        self.frame_zoom_effect(scrollTargets);
        scrollTop = document.documentElement.scrollTop;
      }

      self.timerZoom = requestAnimationFrame(fn);
    });
  }

  frame_zoom_effect(scrollTargets) {
    let wHeight = $(window).height() / 1.5;
    let self = this;
    scrollTargets.map((el) => {
      let elTop = el.getBoundingClientRect().top;
      let vBackground = el.querySelector(".v-full-screen-paint .paint-img");

      if (vBackground.dataset.direction === "vertical") {
        vBackground.setAttribute("style", "");
        vBackground = el.querySelector(".v-full-screen-paint");
      }

      if (elTop <= wHeight) {
        let offsetTop = wHeight - Math.max(0, elTop);
        let offsetRate = offsetTop / wHeight;

        let leftRate = self.clipRate - self.clipRate * offsetRate;
        let rightRate = 100 - self.clipRate + self.clipRate * offsetRate;
        vBackground.style.clipPath = `polygon(${leftRate}% 0%, ${rightRate}% 0%, ${rightRate}% 100%, ${leftRate}% 100%)`;
      } else {
        vBackground.style.clipPath = `polygon(${self.clipRate}% 0%, ${
          100 - self.clipRate
        }% 0%, ${100 - self.clipRate}% 100%, ${self.clipRate}% 100%)`;
      }
    });
  }
}
